import { GuaranteedRentWithBelongXCard } from 'src/features/homeowners/components/guaranteed-rent-with-belong-x-card/guaranteed-rent-with-belong-x-card';

export const GuaranteedRentWithBelongXCardSlice = GuaranteedRentWithBelongXCard;
